var classes = {"productCardInformation":"DHnbK","leftPair":"HcQg9","right":"_79xDp","leftFull":"lv-uh","rightFirst":"_766mG"};

export { classes as default };
